<!---------------------------------new ui---------------------------------------------------->

<section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Attendance Request</h1>
    </div>
    </div>
<!-- 🔽 Filter Dropdown (no backend) -->
<div class="form-group mt-3" style="max-width: 250px;">
  <label class="form-label fw-bold">Filter by Status</label>
  <ng-select
    [items]="statusOptions"
    bindLabel="label"
    bindValue="value"
    placeholder="Select Status"
    [(ngModel)]="filterStatus"
    (change)="onFilterChange($event)"
  >
  </ng-select>
</div>

<!-- ✅ NEW: Bulk Approve Button -->
<div class="mt-3 mb-3" *ngIf="filterStatus === 'Requested' && selectedRequests.size > 0">
  <button class="btn btn-success" (click)="approveSelected()">
    <i class="fas fa-check-circle"></i>
    Approve Selected ({{selectedRequests.size}})
  </button>
</div>

    
</section>

    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    <section class="content">
    
    <div class="card"  *ngIf=tableShown >
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
        <div class="table-responsive">
    <table class="table table-striped projects">
    <thead>
<tr>
<!-- ✅ NEW: Master checkbox column -->
<th style="width: 5%" *ngIf="filterStatus === 'Requested'">
  <input 
    type="checkbox" 
    [(ngModel)]="selectAll"
    (change)="toggleSelectAll($event)"
    title="Select All">
</th>

<th style="width: 25%" >
Employee Name
</th>

    <th style="width: 25%">
    Date
    </th>
    <th style="width: 15%">
    Punching Type
    </th>
    <th style="width: 25%">
        Forenoon Checkin
    </th>
    <th style="width: 25%">
        Forenoon Checkout
    </th>
    <th style="width: 25%">
        Afternoon&nbsp;Checkin
        </th>
    <th style="width: 25%">
        Afternoon&nbsp;Checkout
    </th>
    <th style="width: 25%">
        Customer
    </th>

    <th style="width: 25%">
        Department
    </th>

    <!-- <th style="width: 15%">
    Check-in/Check-out
    </th> -->

    <th style="width: 15%" class="px-5">
    Reason
    </th>

    <th style="width: 10%">
    Status
    </th>
    
     
    <th class="px-5">
        Action
    </th>
    <th  *ngIf="useType">
    </th>
   
    </tr>
    </thead>
    <tbody>

<tr *ngFor="let c of output">
<!-- ✅ NEW: Individual checkbox -->
<td *ngIf="filterStatus === 'Requested'">
  <input 
    *ngIf="c.status === 'Requested'"
    type="checkbox" 
    [checked]="isSelected(c._id)"
    (change)="toggleSelection(c._id, $event)">
</td>

<td>
<a>    
{{c.employee_name}}
</a>
</td>
    
    <td>
      <span *ngIf="c.punching_type === 'Mobile Punching' && c.requested_for_date">
        {{DateFormat(c.requested_for_date)}}
      </span>
      <span *ngIf="c.punching_type === 'Biometric Punching' && c.requested_date_time">
        {{DateFormat(c.requested_date_time)}}
      </span>
      <span *ngIf="!c.requested_for_date && !c.requested_date_time">
        -
      </span>
    </td>
     <td>
  <div>
    <span>{{c.punching_type || '-'}}</span>
    
    <!-- Badge style for Biometric Punching requested_type -->
    <span *ngIf="c.punching_type === 'Biometric Punching' && c.requested_type" class="d-block mt-1">
      <!-- Blue badge for Add -->
      <span *ngIf="c.requested_type.toLowerCase().includes('add') || c.requested_type.toLowerCase().includes('check-in') || c.requested_type.toLowerCase().includes('checkin')" 
            style="background-color: #3a94f4; color: white; padding: 2px 10px; border-radius: 12px; display: inline-block; font-size: 10px; font-weight: 600; text-transform: uppercase;">
        ADD
      </span>
      
      <!-- Red badge for Remove -->
      <span *ngIf="c.requested_type.toLowerCase().includes('remove') || c.requested_type.toLowerCase().includes('check-out') || c.requested_type.toLowerCase().includes('checkout')" 
            style="background-color: #FF0000; color: white; padding: 2px 10px; border-radius: 12px; display: inline-block; font-size: 10px; font-weight: 600; text-transform: uppercase;">
        REMOVE
      </span>
    </span>
  </div>
</td>
    <td>
    {{DateandtimeFormat(c.forenoon_checkin_time)}}
    </td>
    <td>
    {{DateandtimeFormat(c.forenoon_checkout_time)}}
    </td>
    <td>
    {{DateandtimeFormat(c.afternoon_checkin_time)}}
    </td>
    <td>
    {{DateandtimeFormat(c.afternoon_checkout_time)}}
    </td>
    <td>
        {{c.customer_name}}
    </td>
    <td>
        {{c.department_name}}
    </td>

    
    <!-- <td>
    {{c.machine_name}}
    </td> -->
    
    <td class="px-5" style="max-width: 200px;">
  <span [title]="c.reason" style="display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
    {{c.reason || '-'}}
  </span>
</td>
    <td>
    {{c.status}}
    </td>

    <!-- <td *ngIf="c.approve">
     Approved
    </td>

    <td *ngIf="!c.approve">
    Pending
    </td> -->
    
    
    <td class="project-actions text-right">
  <ng-container *ngIf="c.status === 'Requested'">
    <!-- ✅ Pass entire record 'c' instead of just 'c._id' -->
    <button class="btn btn-primary btn-sm" (click)="Approve(c)">
      <i class="fas fa-award"></i>
      Approve
    </button>
    <button class="btn btn-danger btn-sm mt-1 ps-4" (click)="Reject(c)">
      <i class="fas fa-trash"></i>
      Reject
    </button>
  </ng-container>
  
  <span *ngIf="c.status !== 'Requested'" class="text-muted">
    {{c.status}}
  </span>
</td>
    <td *ngIf="useType" >
        <button class="btn btn-info btn-sm px-4" routerLink="/admin/Attendance-request-edit" [queryParams]="{id:c._id}" >Edit</button>
    </td>
    </tr>
    

    </tbody>
    </table>
</div>
    </div>
    
    </div>
    
    </section>
    <!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=tableShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>